import Request from '../../../gd/data/request'
import Team from '../../../model2/team/team'

export default class ApiTeam {

    // static getAll() {
    //     return new Request(this, 'GET', 'teams')
    // }

    static create(team:Team) {
        return new Request(this, 'POST', 'teams/create', team.toJSON())
    }

    static get(teamId: string) {
        return new Request(this, 'GET', 'teams/'+teamId)
    }

    static update(teamId: string, params: {
        name?: string
        description?: string,
        userIds?: ID[]
    }) {
        return new Request(this, 'PUT', 'teams/'+teamId, params)
    }

    static delete(teamId: string, deleteProjectTeamUsers: boolean = false, checkAssignedProjects: boolean = true) {
        return new Request(this, 'DELETE', 'teams/'+teamId + "?deleteProjectTeamUsers={0}&checkAssignedProjects={1}".f(deleteProjectTeamUsers, checkAssignedProjects))
    }

    // static addMember(teamId: string, userId: string) {
    //     return new Request(this, 'POST', 'teams/'+teamId+'/members', {
    //         userId: userId
    //     })
    // }

    // static removeMember(teamId: string, userId: string) {
    //     return new Request(this, 'DELETE', 'teams/'+teamId+'/members/'+userId)
    // }

    // static getMembers(teamId: string) {
    //     return new Request(this, 'GET', 'teams/'+teamId+'/members')
    // }

}
